<template>
  <div>
    <div
      class="grid-cols-4"
      :class="
        isJobPreview
          ? 'pt-18 2xl:grid 2xl:pr-container-desktop-wide'
          : 'mt-navigation-desktop pt-20 xl:grid xl:pr-container-desktop-wide'
      "
    >
      <div class="col-span-3">
        <!-- HERO -->
        <HeroJob :data="page" />

        <!-- CONTENT SIDEBAR -->
        <ComponentsLoader
          v-editor-target="'job_replicator_components_sidebar'"
          :components="page.job_replicator_components_sidebar"
        />

        <Container indent="wide">
          <div
            class="my-14 space-y-8 bg-gradient-to-tr from-blue-50/60 to-blue-10/60 px-6 py-10"
            :class="isJobPreview ? '2xl:hidden' : 'xl:hidden'"
          >
            <JobContacts :page="page" />

            <AppButton
              v-if="page.link_to_online_application"
              :to="page.link_to_online_application"
            >
              {{ $t('to_online_application') }}
            </AppButton>
          </div>

          <SocialShareIcons
            :alternates="page.alternates"
            class="mt-12 xl:mt-32"
            :class="isJobPreview ? '2xl:mt-32' : 'xl:mt-32'"
          />
        </Container>
      </div>
      <AnimatedContainer>
        <JobSidebar
          class="fade-in hidden"
          :class="isJobPreview ? '2xl:block !static mt-12' : 'xl:block'"
          :page="page"
        />
      </AnimatedContainer>
    </div>

    <!-- CONTENT -->
    <div class="pt-16 sm:pt-28">
      <ComponentsLoader
        v-editor-target="'job_replicator_components'"
        :components="page.job_replicator_components"
      />
    </div>
  </div>
</template>

<script setup>
const { setIsWhite } = useNavigationStore()

onMounted(() => {
  setIsWhite(true)
})

defineProps({
  page: { type: Object, required: true },
})

provide('isJob', true)
const isJobPreview = inject('isJobPreview', false)
</script>
